"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var styles_1 = require("@material-ui/core/styles");
exports.imageStyle = {
    width: '100%',
    height: 'unset',
    position: 'relative',
    top: 'unset',
    left: 'unset',
};
var itemDetailsStyles = styles_1.makeStyles(function (_a) {
    var typography = _a.typography;
    return ({
        image: {
            display: 'block',
            marginBottom: '15px',
            maxWidth: '100%',
        },
        details: {
            padding: '0 15px',
            textAlign: 'left',
        },
        title: {
            fontWeight: 700,
            fontSize: typography.fontMD,
            marginBottom: '5px',
        },
        description: {
            lineHeight: '18px',
        },
    });
}, { name: 'GqlCheckout_ExpressionsOfInterest_ItemDetails' });
exports.default = itemDetailsStyles;
